export const formatShortDate = (date, locale) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  const formatter = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  if (!String(locale || "").toLowerCase().startsWith("de")) {
    return formatter.format(date);
  }

  const parts = formatter.formatToParts(date);
  const day = parts.find((part) => part.type === "day")?.value ?? "";
  const month = parts.find((part) => part.type === "month")?.value ?? "";
  const year = parts.find((part) => part.type === "year")?.value ?? "";

  return [day, month, year].filter(Boolean).join(" ");
};
